<template>
  <v-card>
    <v-card-title color="rgba(0, 0, 0, 0.6)">New Connection</v-card-title>
    <v-list-item>
      <v-list-item-avatar color="grey">
        <v-img :src="avatarImage()"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">{{ connectionName() }}</v-list-item-title>
        <v-list-item-subtitle v-if="entity.entity.parentName.length > 0">by {{ entity.entity.parentName }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text v-html="entity.entity.description">
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        :loading="loading"
        color="blue accent-4"
        @click="$emit('accept')"
      >
        Accept
      </v-btn>
      <v-btn
        text
        v-if="!loading"
        color="blue accent-4"
        @click="$emit('cancel')"
      >
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ConnectionRequest',
  props: ['entity', 'loading'],
  methods: {
    avatarImage () {
      if (this.entity.entity.image) {
        return this.entity.entity.image.find(e => e.type === 'avatar').location || ''
      }
      return ''
    },
    connectionName () {
      console.log(this.entity)
      return this.entity.entity.name.Label || `${this.entity.entity.name.First} ${this.entity.entity.name.Last}`
    }
  }
}
</script>
